import axios from 'axios';
import { MasterDataURL } from '../../../../config/UrlEndPoint';

export const URL = `${MasterDataURL}fundtype`;
export const URLCOA = `${MasterDataURL}coa`
// CREATE - item
export function createFundtype(fundtype) {
    return axios.post(URL, fundtype);
}

// READ - get All item
export function getFundtypeAll() {
    return axios.get(URL)
}

export function getFundtypeProgramAll() {
    return axios.get(`${URL}/list/fundtype_program`)
}

export function getFundTypeForProgramCombobox() {
    return axios.get(`${URL}/list/for_program`)
}

// READ - Get item by type name`
export function getFundtype(type) {
    return axios.post(`${URL}/find`, type);
}

// READ - get Item by ID PARAMS
export function getFundtypeById(fundtypeId) {
    return axios.get(`${URL}/${fundtypeId}`);
}

// UPDATE => PUT: update the fundtype on the server
export function updateFundtype(fundtype) {
    return axios.put(`${URL}/${fundtype.uuid}`, fundtype);
}

export function getCoaAccountNumber(db, account_type) {
    return axios.post(`${URLCOA}/get_all_account_number`, { db, account_type });
}



